module.exports = __webpack_public_path__ + "img/1-3.f3e87491.svg";